export enum LocalizationId {
    Title = "privacy-policy-and-terms-and-conditions-confirm-dialog.title",
    PrivacyPolicyLabel = "privacy-policy-and-terms-and-conditions-confirm-dialog.privacy_policy_label",
    TermsAndConditionsLabel = "privacy-policy-and-terms-and-conditions-confirm-dialog.terms_and_conditions_label",
    ConfirmPoliciesText = "privacy-policy-and-terms-and-conditions-confirm-dialog.confirm_policies_text",
    ConfirmPoliciesButtonText = "privacy-policy-and-terms-and-conditions-confirm-dialog.confirm_policies_button_text",
}
